import { NGET, NPOST } from '@/utils/net-work'
const baseUri = '/api'

// 获取班级信息
function getTeacherGroupInfo(params: any) {
  return NGET(baseUri + '/auth/teacher-group-info', params)
}

// 获取点阵试卷名
function getDotMatrixPaper(params: any) {
  return NGET(baseUri + '/dot_matrix/paper', params)
}

// 获取排版⻚面
function getDotMatrixTypeset(params: any) {
  return NGET(baseUri + '/dot_matrix/typeset', params)
}

// 提交布局
function publishDotMatrixTypeset(params: any) {
  return NPOST(baseUri + '/dot_matrix/typeset', params)
}

// 发布排版⻚面
function publishDotMatrix(params: any) {
  return NPOST(baseUri + '/dot_matrix/publish', params)
}

// 订正与反思
function getDotMatrixCard(params: any) {
  return NGET(baseUri + '/dot_matrix/card', params)
}

// 订正与反思
function updateDotMatrixCard(params: any) {
  return NPOST(baseUri + '/dot_matrix/card', params)
}

export {
  getTeacherGroupInfo,
  getDotMatrixPaper,
  getDotMatrixTypeset,
  publishDotMatrixTypeset,
  publishDotMatrix,
  getDotMatrixCard,
  updateDotMatrixCard
}
